import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/overlay';
import { Component, computed, effect, input, WritableSignal } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { cloneDeep, pullAt, without } from 'lodash';

@Component({
  imports: [
    MatExpansionPanel,
    MatCheckbox,
    TranslatePipe,
    CdkDropList,
    CdkDrag,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    CdkScrollable,
    MatIcon,
  ],
  selector: 'filter-mode-selection-and-ordering-panel',
  styleUrl: './filter-mode-selection-and-ordering-panel.component.scss',
  templateUrl: './filter-mode-selection-and-ordering-panel.component.html',
})
export class FilterModeSelectionAndOrderingPanelComponent {
  public readonly filterModeOrder = input.required<WritableSignal<string[]>>();
  public readonly modeNamesOfWidget = input.required<string[]>();
  public readonly uncheckedRows = computed(() => {
    try {
      return without(this.modeNamesOfWidget(), ...this.filterModeOrder()());
    } catch {
      return [];
    }
  });

  constructor() {
    effect(() => {
      if (this.modeNamesOfWidget().length === 1) {
        this.filterModeOrder().set([...this.modeNamesOfWidget()]);
      }
    });
  }

  public uncheck(checkedRow: string): void {
    this.filterModeOrder().update((modes) => without(modes, checkedRow));
  }

  public check(checkedRow: string): void {
    this.filterModeOrder().update((modes) => [...modes, checkedRow]);
  }

  public drop(cdkDragDrop: CdkDragDrop<any, any>): void {
    this.filterModeOrder().update((modes) => {
      const clone = cloneDeep(modes);
      const mode = clone[cdkDragDrop.previousIndex];
      pullAt(clone, cdkDragDrop.previousIndex);

      return [...clone.slice(0, cdkDragDrop.currentIndex), mode, ...clone.slice(cdkDragDrop.currentIndex)];
    });
  }
}
